import styled from 'styled-components';

// Container do picker — botao trigger + dropdown que aparece on-demand.
// Position relative pro dropdown absolute interno.
export const Container = styled.div`
  position: relative;
  display: inline-flex;
`;

// Botao trigger no header do modal — mostra "+ Comparar" ou
// "Comparando: VAR1, VAR2" dependendo do estado.
export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 12px;
  border-radius: 10px;
  font-family: inherit;
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 180ms ease;
  border: 1px solid
    ${(props) =>
      props.$active
        ? props.theme.colors.lightblue
        : props.theme.colors.disabled};
  background: ${(props) =>
    props.$active ? props.theme.colors.lightblue : 'transparent'};
  color: ${(props) =>
    props.$active ? props.theme.colors.white : props.theme.colors.label};

  :hover {
    border-color: ${(props) => props.theme.colors.lightblue};
    color: ${(props) =>
      props.$active ? props.theme.colors.white : props.theme.colors.lightblue};
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.lightblue};
  font-size: 9px;
  font-weight: 800;
  margin-left: 2px;
`;

// Dropdown flutuante — lista de variaveis disponiveis. Max-height +
// overflow-y pra listas grandes. Z-index alto pra ficar sobre o
// AdvancedHeader.
export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 200;
  width: 260px;
  max-height: 320px;
  overflow-y: auto;
  background: ${(props) => props.theme.colors.card};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  border-radius: 8px;
  box-shadow: none;
  padding: 6px;
`;

export const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 8px;
  border-bottom: 1px solid ${(props) => props.theme.colors.disabled};
  margin-bottom: 6px;
`;

export const DropdownTitle = styled.span`
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.colors.label};
`;

export const DropdownHint = styled.span`
  font-size: 10px;
  color: ${(props) => props.theme.colors.label};
  opacity: 0.7;
`;

export const Option = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: ${(props) =>
    props.$selected
      ? props.theme.title === 'light'
        ? 'rgba(0, 159, 216, 0.10)'
        : 'rgba(59, 191, 241, 0.14)'
      : 'transparent'};
  color: ${(props) => props.theme.colors.darkerblue};
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: ${(props) => (props.$selected ? 700 : 500)};
  text-align: left;
  transition: background 120ms ease;

  :hover:not(:disabled) {
    background: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 159, 216, 0.07)'
        : 'rgba(59, 191, 241, 0.10)'};
  }

  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

// Dot colorido indicando que a variavel esta selecionada (cor da serie
// no chart). Usado tanto no dropdown qto na legenda.
export const ColorDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.color};
  flex-shrink: 0;
`;

// Spinner que substitui o ColorDot quando a serie esta carregando.
// Visual: anel girando na cor da serie + borda translucida.
export const DotSpinner = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1.5px solid
    ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.15)'
        : 'rgba(255, 255, 255, 0.15)'};
  border-top-color: ${(props) => props.color || props.theme.colors.lightblue};
  animation: spin 700ms linear infinite;
  flex-shrink: 0;
`;

export const ColorDotPlaceholder = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px dashed ${(props) => props.theme.colors.disabled};
  flex-shrink: 0;
`;

export const OptionLabel = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OptionUnit = styled.span`
  font-size: 10px;
  color: ${(props) => props.theme.colors.label};
  font-weight: 600;
`;

export const Empty = styled.div`
  padding: 14px;
  text-align: center;
  font-size: 11px;
  font-style: italic;
  color: ${(props) => props.theme.colors.label};
`;
